<mat-form-field appearance="fill">
  <mat-label>Category</mat-label>
  <mat-select [(value)]="categoryId" aria-readonly="true">
    <mat-option>None</mat-option>
    <mat-option *ngFor="let category of categories" [value]="category.id">{{category.name}}</mat-option>
  </mat-select>
</mat-form-field>
